<template>
  <div class="partnet">
    <div class="header">
      <swiper
        :options="swiperOption"
        class="swiper-container"
        id="home"
        :style="{ height: 350 +'px'}"
      >
        <!-- slides -->
        <swiper-slide class="swiper-item" v-for="item of swiperList1" :key="item.id">
          <img class="swiper-img" :src="item.imgUrl" alt>
        </swiper-slide>
      </swiper>
      <div class="nav">
        <img src="../../assets/logo.png" alt class="logo">
        <router-link to="/" class="back">
          <span>返回主菜单</span>
          <img src="../../assets/back.png" alt="back">
        </router-link>
      </div>
    </div>
    <div class="body">
      <div class="left">
        <div class="part_1">
          <img src="../../assets/pars1.png" alt class="partner_logo">
          <p
            class="part_info"
            v-html="partnerInfo.copy_writing_content"
          >{{partnerInfo.copy_writing_content}}</p>
          <div class="part_btn">
            <img src="../../assets/pars5.png" alt class="vict_logo">
            <div class="vict">
              <span :class="{active: curTab === 1}" @click="onChangeTab(1)">川口工厂</span>
              <span :class="{active: curTab === 2}" @click="onChangeTab(2)">野田工厂</span>
              <span :class="{active: curTab === 3}" @click="onChangeTab(3)">野田第二工厂</span>
            </div>
          </div>
        </div>
        <div class="part_2">
          <h3>KHK视频介绍</h3>
          <video
            :src="partnerVideo.video_address"
            class="vide"
            controls="controls"
            poster="../../assets/video/KHK工厂介绍.mp4.jpg"
          ></video>
        </div>
        <div class="part_3">
          <h3>KHK厂址地理示意图</h3>
          <img src="../../assets/pars6.png" class="address">
        </div>
      </div>
      <div class="right">
        <ul>
          <li v-for="(item, index) in partnerData" :key="index">
            <h3 class="name">{{item.title_name}}</h3>
            <p class="right_info">{{item.info}}</p>
            <img :src="item.img" alt class="right_img">
            <div class="right_list">
              <h3>主要设备：</h3>
              <p v-for="(data, i) in item.arr" :key="i" class="right_list_item">{{data}},</p>
            </div>
            <div class="back_top" @click="handleScrollTop">返回顶部</div>
          </li>
        </ul>
      </div>
    </div>
    <mb-fotter></mb-fotter>
  </div>
</template>

<script>
import mbFotter from "../../components/mb-fotter.vue";
import request from "../../server/request.js";

export default {
  data() {
    return {
      partnerData: [
        {
          id: 1,
          title_name: "川口工厂",
          info:
            "川口工厂主要从事定制齿轮和追加工齿轮的制造。KHK齿轮的设计和开发也全部在这里进行。",
          img: require("../../assets/pars2.png"),
          arr: [
            "复核加工机(Mazak)",
            "立式加工中心(Mazak)",
            "立式加工中心(KIRA)",
            "数控齿轮加工机床(Kashifuji)",
            "数控齿轮磨床(Gleason)",
            "线切割放电加工机(FANUC)",
            "数控三维测量仪(Mitsutoyo)"
          ]
        },
        {
          id: 2,
          title_name: "野田工厂",
          info:
            "几乎所有的KHK库存标准齿轮都在野田工厂生产。齿条和锥齿轮的定做品也包括在内。在部分工序中，通过工业自动化以节省人力正在逐步推进。",
          img: require("../../assets/pars3.png"),
          arr: [
            "数控车床(Muratec)，数控齿条切齿机(Saikuni)",
            "蜗杆磨床(Drake)，数控插齿机(Mitsubishi)",
            "数控车床(Tsugami)，数控锥齿轮切齿机(Gleason)",
            "数控磨齿机(Gleason)，立式加工中心(Mazak)",
            "数控弧齿锥齿轮磨齿机(格里森)",
            "数控三坐标测量仪(ZEISS)"
          ]
        },
        {
          id: 3,
          title_name: "野田第二工厂",
          info:
            "高频淬火热处理后的硬度测试，喷丸处理，蜗轮切齿加工等等在第二工厂进行。",
          img: require("../../assets/pars4.png"),
          arr: ["激光淬火装置(Laserline)", "高频淬火炉(NETUREN)"]
        }
      ],
      curTab: 0,
      scrollToptimer: null,
      partnerInfo: {},
      partnerVideo: {},
      swiperOption: {
        autoplay: true,
        speed: 2000,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        }
      },
      swiperList1: [
        {
          id: 2,
          imgUrl: require("../../assets/s1.jpg")
        },
        {
          id: 3,
          imgUrl: require("../../assets/s2.jpg")
        },
        {
          id: 1,
          imgUrl: require("../../assets/s3.jpg")
        }
      ]
    };
  },
  components: {
    mbFotter
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      request.getPartnerInfo(res => {
        if (res && res.errcode === 0) {
          this.partnerInfo = res.data[0];
        }
      });

      request.getVideo(res => {
        if (res && res.errcode === 0) {
          if (
            res.data.filter(item => item.video_location === "partner_info")
              .length > 0
          ) {
            this.partnerVideo = res.data[0];
          }
        }
      });
    },
    handleScrollTop() {
      let that = this;
      this.scrollToptimer = setInterval(function() {
        clearInterval(this.scrollToptimer);
        let top = document.body.scrollTop || document.documentElement.scrollTop;
        let speed = top / 4;
        if (document.body.scrollTop != 0) {
          document.body.scrollTop -= speed;
        } else {
          document.documentElement.scrollTop -= speed;
        }
        if (top === 0) {
          clearInterval(that.scrollToptimer);
        }
      }, 30);
    },
    onChangeTab(tab) {
      this.curTab = tab;
      if (tab === 1) {
        window.scrollTo(0, 350);
      }
      if (tab === 2) {
        window.scrollTo(0, 976);
      }
      if (tab === 3) {
        window.scrollTo(0, 2830);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.partnet {
  background: #ecfcff;
  .header {
    .swiper-container {
      width: 100%;
      // height: 12rem;
      background-size: 100% 100%;
      .swiper-item {
        img {
          width: 100%;
          height: 100%;
          vertical-align: top;
          -o-object-fit: cover;
          object-fit: cover;
        }
      }
    }
    .nav {
      position: absolute;
      left: 0;
      top: 20px;
      display: flex;
      width: 100%;
      z-index: 10;
      justify-content: space-between;
      align-items: center;
      padding: 0 1rem;
      .back {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          margin-right: 5px;
        }
      }
    }
  }
  .body {
    padding-bottom: 0.1rem;
    display: flex;
    // width: 100%;
    justify-content: center;
    // align-items: center;
    .left {
      width: 30%;
      margin-left: 15%;
      margin-right: 3%;
      margin-top: 0.5rem;
      .part_1 {
        .partner_logo {
          margin-bottom: 0.3rem;
          width: 100%;
        }
        .part_info {
          margin: 0.36rem 0;
          font-size: 0.28rem;
          line-height: 1.7;
          margin: 0;
          margin-bottom: 0.3rem;
          font-weight: 800;
          .part_info_active {
            color: #ff0000;
          }
        }
        .part_btn {
          display: flex;
          .vict_logo {
            width: 3.6rem;
          }
          .vict {
            display: flex;
            flex-direction: column;
            margin-left: 20%;
            width: 60%;

            span {
              display: inline-block;
              cursor: pointer;
              border: 1px solid #0583c9;
              width: 100%;
              height: 0.88rem;
              line-height: 0.88rem;
              text-align: center;
              margin-top: 0.48rem;
              color: #0583c9;
              border-radius: 2px;
              font-weight: 600;
              font-size: 0.34rem;
              letter-spacing: 2px;
              &:hover {
                color: #fff;
                background: #0583c9;
              }
              &:first-child {
                margin-top: 0;
              }
              &.active {
                color: #fff;
                background: #0583c9;
              }
            }
          }
        }
      }
      .part_2 {
        margin-top: 1.7rem;
        h3 {
          color: #f30606;
          font-weight: 700;
          font-size: 0.32rem;
        }
        .vide {
          width: 100%;
          outline: none;
        }
      }
      .part_3 {
        margin-top: 1.7rem;
        h3 {
          color: #f30606;
          font-weight: 700;
          font-size: 0.32rem;
        }
        .address {
          width: 100%;
        }
      }
    }
    .right {
      margin-top: 0.5rem;
      // width: 60%;
      ul {
        border-left: 1px solid #0583c9;
        width: 100%;
        li {
          border-bottom: 1px solid #0583c9;
          width: 100%;
          padding-left: 10%;
          padding-bottom: 0.3rem;
          .name {
            color: #c9051c;
          }
          &:last-child {
            border-bottom: none;
          }
          .right_info,
          .right_img {
            width: 60%;
          }
          p.right_info {
            line-height: 1.5;
            color: #0583c9;
          }
          .right_list {
            h3 {
              font-weight: 600;
              color: #0583c9;
            }
            .right_list_item {
              margin-left: 4%;
              color: #0583c9;
            }
          }
          .back_top {
            width: 2rem;
            height: 0.68rem;
            background: #0583c9;
            color: #fff;
            text-align: center;
            line-height: 0.68rem;
            border-radius: 5px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1480px) {
  .partnet {
    .body {
      .left {
        margin-left: 8%;
      }
    }
  }
}
</style>
